import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import Select from "../../../components/forms/Select/Select";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";

export default function TeamFilters({
  regionFilter,
  setRegionFilter,
  isPassedFilter,
  setIsPassedFilter,
  levelFilter,
  setLevelFilter,
  teamMemberSearchFilter,
  setTeamMemberSearchFilter,
  teamNameSearchFilter,
  setTeamNameSearchFilter,
  regions,
  isExamCenterAdmin,
}) {
  const [t] = useTranslation();
  const [teamMemberSearchInput, setTeamMemberSearchInput] = useState(
    teamMemberSearchFilter
  );
  const [teamNameSearchInput, setTeamNameSearchInput] =
    useState(teamNameSearchFilter);
  const teamMemberSearchTimeoutRef = useRef(null);
  const teamNameSearchTimeoutRef = useRef(null);

  useEffect(() => {
    setTeamMemberSearchInput(teamMemberSearchFilter);
  }, [teamMemberSearchFilter]);

  useEffect(() => {
    setTeamNameSearchInput(teamNameSearchFilter);
  }, [teamNameSearchFilter]);

  // Debounce team member search filter
  useEffect(() => {
    if (teamMemberSearchTimeoutRef.current) {
      clearTimeout(teamMemberSearchTimeoutRef.current);
    }

    teamMemberSearchTimeoutRef.current = setTimeout(() => {
      setTeamMemberSearchFilter(teamMemberSearchInput || "");
    }, 600);

    return () => {
      if (teamMemberSearchTimeoutRef.current) {
        clearTimeout(teamMemberSearchTimeoutRef.current);
      }
    };
  }, [teamMemberSearchInput, setTeamMemberSearchFilter]);

  // Debounce team name search filter
  useEffect(() => {
    if (teamNameSearchTimeoutRef.current) {
      clearTimeout(teamNameSearchTimeoutRef.current);
    }

    teamNameSearchTimeoutRef.current = setTimeout(() => {
      setTeamNameSearchFilter(teamNameSearchInput || "");
    }, 600);

    return () => {
      if (teamNameSearchTimeoutRef.current) {
        clearTimeout(teamNameSearchTimeoutRef.current);
      }
    };
  }, [teamNameSearchInput, setTeamNameSearchFilter]);

  const statusOptions = [
    { label: t("admin.all"), value: null },
    { label: t("team.draft"), value: "DRAFT" },
    { label: t("team.approved"), value: "APPROVED" },
  ];

  return (
    <div className="mb-4 flex flex-wrap gap-4">
      <div className="flex flex-col group justify-end relative w-64">
        <label className="text-xs transition-all delay-100 cursor-text">
          {t("admin.team_name_search")}
        </label>
        <input
          value={teamNameSearchInput}
          onChange={(e) => setTeamNameSearchInput(e.target.value)}
          className="block w-full rounded-md border-gray-300 px-3 py-2 pr-12 shadow-sm disabled:bg-slate-200 text-sm peer"
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              if (teamNameSearchTimeoutRef.current) {
                clearTimeout(teamNameSearchTimeoutRef.current);
              }
              setTeamNameSearchFilter(teamNameSearchInput || "");
            }
          }}
        />
        <div className="absolute right-2 bottom-2.5 cursor-pointer text-primary">
          <MagnifyingGlassIcon
            className="h-5"
            onClick={() => {
              if (teamNameSearchTimeoutRef.current) {
                clearTimeout(teamNameSearchTimeoutRef.current);
              }
              setTeamNameSearchFilter(teamNameSearchInput || "");
            }}
          />
        </div>
      </div>
      <div className="flex flex-col group justify-end relative w-64">
        <label className="text-xs transition-all delay-100 cursor-text">
          {t("admin.team_member_search")}
        </label>
        <input
          value={teamMemberSearchInput}
          onChange={(e) => setTeamMemberSearchInput(e.target.value)}
          className="block w-full rounded-md border-gray-300 px-3 py-2 pr-12 shadow-sm disabled:bg-slate-200 text-sm peer"
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              if (teamMemberSearchTimeoutRef.current) {
                clearTimeout(teamMemberSearchTimeoutRef.current);
              }
              setTeamMemberSearchFilter(teamMemberSearchInput || "");
            }
          }}
        />

        <div className="absolute right-2 bottom-2.5 cursor-pointer text-primary">
          <MagnifyingGlassIcon
            className="h-5"
            onClick={() => {
              if (teamMemberSearchTimeoutRef.current) {
                clearTimeout(teamMemberSearchTimeoutRef.current);
              }
              setTeamMemberSearchFilter(teamMemberSearchInput || "");
            }}
          />
        </div>
      </div>
      {!isExamCenterAdmin && (
        <>
          {" "}
          <div className="w-64">
            <Select
              label={t("admin.filter_region")}
              value={regionFilter}
              onChange={(opt) => setRegionFilter(opt?.value || null)}
              options={[{ label: t("admin.all"), value: null }, ...regions]}
              isSearchable
            />
          </div>
          <div className="w-64">
            <Select
              label={t("admin.is_passed")}
              value={isPassedFilter}
              onChange={(opt) => setIsPassedFilter(opt?.value)}
              options={[
                { label: t("admin.all"), value: null },
                { label: t("admin.yes"), value: true },
                { label: t("admin.no"), value: false },
              ]}
              isSearchable
            />
          </div>
          <div className="w-64">
            <Select
              label={"Тур"}
              value={levelFilter}
              onChange={(opt) => setLevelFilter(opt?.value)}
              options={[1].map((v, i) => ({
                label: `${v} тур`,
                value: `${v}`,
              }))}
              isSearchable
            />
          </div>
          {/* <div className="w-64">
            <Select
              label={t("admin.level")}
              value={levelFilter}
              onChange={(opt) => setLevelFilter(opt?.value || null)}
              options={[{ label: t("admin.all"), value: null }, 1, 2]}
              isSearchable
            />
          </div> */}
          {/* <div className="w-64">
            <Select
              label={t("admin.filter_exam_center")}
              value={examCenterFilter}
              onChange={(opt) => setExamCenterFilter(opt?.value || null)}
              options={[{ label: t("admin.all"), value: null }, ...examCenters]}
              isSearchable
            />
          </div>
          <div className="w-64">
            <Select
              label={t("admin.filter_status")}
              value={statusFilter}
              onChange={(opt) => setStatusFilter(opt.value)}
              options={statusOptions}
            />
          </div> */}
        </>
      )}
    </div>
  );
}
